/**
 * Crop-space helpers for the post crop modal.
 *
 * The crop UI displays the optimized variant (capped at 1400px), but the
 * backend applies stored rects to the full-resolution original. A rect
 * is therefore only meaningful together with the pixel space it was
 * measured in: the modal saves the rect with the loaded image's natural
 * dimensions (sourceWidth/sourceHeight), and the backend rescales it
 * onto the original at preparation time.
 */

import type { Area } from "react-easy-crop";
import type { CropSelection } from "./MediaCropModal";

/**
 * Convert a stored crop selection into a react-easy-crop percentage
 * Area for seeding the cropper. Percentages are variant-independent, so
 * the seed is exact regardless of which variant renders next time.
 */
export function selectionToPercentArea(selection: CropSelection): Area {
  return {
    x: (selection.x / selection.sourceWidth) * 100,
    y: (selection.y / selection.sourceHeight) * 100,
    width: (selection.width / selection.sourceWidth) * 100,
    height: (selection.height / selection.sourceHeight) * 100,
  };
}
